export default __webpack_public_path__ + "fk-cp-zion/img/info-basic_6c1a38.svg";